export const formatNumbers = (float) => {
	let numArr = float.toString().split('.')

	const decimals = numArr[1] ? ',' + numArr[1][0] + (numArr[1][1] || 0) : ''
	const formatted = numArr[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + decimals
	return formatted
}

export const roundTo = (n, digits) => {
	if (digits === undefined) {
		digits = 0;
	}

	var multiplicator = Math.pow(10, digits);
	n = parseFloat((n * multiplicator).toFixed(11));
	return Math.round(n) / multiplicator;
}
